import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/users/UsersPage'))
  const VisitorsPage = lazy(() => import('../modules/apps/visitors/UsersPage'))
  const MembersPage = lazy(() => import('../modules/apps/members/UsersPage'))
  const ClientsPage = lazy(() => import('../modules/apps/clients/UsersPage'))
  const ExpensesPage = lazy(() => import('../modules/apps/expenses/ExpensesPage'))
  const MembershipPage = lazy(() => import('../modules/apps/membership/MembershipPage'))
  const DailyReportPage = lazy(() => import('../modules/apps/dailyreport/DailyReportPages'))
  const ApprovealPage = lazy(() => import('../modules/apps/approval-delete/ApprovalPages'))

  const AttendancePage = lazy(() => import('../modules/apps/attendance/AttendancePages'))
  const ReportPage = lazy(() => import('../modules/apps/report/reportPages'))
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route
          path='builder'
          element={
            <SuspensedView>
              <BuilderPageWrapper />
            </SuspensedView>
          }
        />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/users/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/visitors/*'
          element={
            <SuspensedView>
              <VisitorsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/members/*'
          element={
            <SuspensedView>
              <MembersPage />
            </SuspensedView>
          }
        />
         <Route
          path='apps/membership/*'
          element={
            <SuspensedView>
              <MembershipPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/clients/*'
          element={
            <SuspensedView>
              <ClientsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/expenses/*'
          element={
            <SuspensedView>
              <ExpensesPage />
            </SuspensedView>
          }
        />
        <Route
          path='dailyreport/*'
          element={
            <SuspensedView>
              <DailyReportPage />
            </SuspensedView>
          }
        />
        <Route
          path='approval/*'
          element={
            <SuspensedView>
              <ApprovealPage />
            </SuspensedView>
          }
        />
        <Route
          path='attendance/*'
          element={
            <SuspensedView>
              <AttendancePage />
            </SuspensedView>
          }
        />
        <Route
          path='report/*'
          element={
            <SuspensedView>
              <ReportPage />
            </SuspensedView>
          }
        />
        {/* ApprovealPage */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
